import styled from 'styled-components';

export const ArticleSection = styled.div`
  .accordion-header-expanded {
    color: #314259;
    font-weight: 700;
  }
`;

export const ArticleWrapper = styled.div`
  h2 {
    font-size: 32px;
    font-weight: 700;
    margin: 48px 0 16px;
  }
  p {
    font-size: 20px;
    color: #9092a3;
    margin-bottom: 40px;
    font-weight: 400;
  }

  a {
    color: #1572ed;
  }
  a:hover {
    text-decoration: underline;
  }

  li {
    font-size: 20px;
    color: #9092a3;
    margin-bottom: 16px;
  }
  ol {
    list-style-type: decimal;
    padding-left: 24px;
  }

  ul {
    list-style-type: disc;
    padding-left: 24px;
  }

  @media (max-width: 767px) {
    h2 {
      font-size: 18px;
      margin: 16px 0 8px;
    }
    p {
      font-size: 16px;
      margin-bottom: 28px;
    }
    li {
      font-size: 16px;
    }
    ol,
    ul {
      padding-left: 16px;
    }
  }
`;

export const ToCContainer = styled.div`
  .tocHead {
    border-bottom: 0.5px solid #e5e5e9;
  }
  .tocItem {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const CardWrap = styled.div`
  a:hover {
    text-decoration: underline;
  }
`;
